export const REFERRAL_ACHIEVEMENT_TRADES_THRESHOLD = 25;
export const REFERRAL_EXPIRATION_DAYS = 30;
export const REFERRAL_CODE_LENGTH = 6;
export const REFERRAL_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
